import SeatGrid from '../reservation/SeatGrid'
import React from 'react'
import PropTypes from 'prop-types'
const stageStyle = { margin: '20px auto', width: '60%', padding: '10px', background: '#333', color: 'white', borderRadius: '10px' }

export default function AdminSeatGrid({ showId, scheduleId, seats, onSeatClick }) {
  if (!showId || !scheduleId) return null

  return (
    <>
      <div style={stageStyle}>SCÈNE</div>
      <SeatGrid initialSeats={seats} selectedSeats={[]} onSeatClick={onSeatClick} sessionUUID={null} allowClickOnOccupied />
    </>
  )
}

AdminSeatGrid.propTypes = {
  showId: PropTypes.string.isRequired,
  scheduleId: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  seats: PropTypes.array.isRequired,
  onSeatClick: PropTypes.func.isRequired
}
